import React from "react";

const WhatIsChildCreditActivityMonitoring = (props: any) => {
    return (
        <div>
            <ul>
                <li>
                    <div className="row">
                        <div className={"col-xs-1"} style={{ maxWidth: "30px" }}>
                            <strong>&#x2022;</strong>
                        </div>
                        <div className={"col-xs-11"}>
                            <p>
                                Upon successful enrollment, the product checks to see if a TransUnion credit file exists with your child's/dependent's SSN and
                                provides you with the results.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="row">
                        <div className={"col-xs-1"} style={{ maxWidth: "30px" }}>
                            <p>
                                <strong>&#x2022;</strong>
                            </p>
                        </div>
                        <div className={"col-xs-11"}>
                            <p>
                                {" "}
                                Ongoing monitoring of your child's/dependent's SSN related to credit file activity identified by TransUnion and notification of
                                credit file activity.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="row">
                        <div className={"col-xs-1"} style={{ maxWidth: "30px" }}>
                            <p>
                                <strong>&#x2022;</strong>
                            </p>
                        </div>
                        <div className={"col-xs-11"}>
                            <p>
                                {" "}
                                A monthly all-clear notification if there is no identified credit file activity for your monitored children/dependents in the prior
                                month.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="row">
                        <div className={"col-xs-1"} style={{ maxWidth: "30px" }}>
                            <p>
                                <strong>&#x2022;</strong>
                            </p>
                        </div>
                        <div className={"col-xs-11"}>
                            <p> Information on possible steps should you suspect your child's/dependent's identity is being used fraudulently.</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="row">
                        <div className={"col-xs-1"} style={{ maxWidth: "30px" }}>
                            <p>
                                <strong>&#x2022;</strong>
                            </p>
                        </div>
                        <div className={"col-xs-11"}>
                            <p>
                                Peace of mind that you are being notified of credit file activity identified by TransUnion related to your child's/dependent's SSN.
                            </p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default WhatIsChildCreditActivityMonitoring;
